import Summary from './Summary';
import { withI18n } from 'react-i18next';

export default withI18n()(Summary);
